// Conexión con el backend: override en memoria (modo embebido: lo fija EmbeddedApp con el token y
// la URL de SherpaCRM) > localStorage (standalone: la barra CONFIG guarda el perfil elegido).
const STORAGE_KEY = 'vem:sherpaConfig';

let override = {};

export function setRuntimeOverride(partial) {
  override = { ...override, ...partial };
}

export function clearRuntimeOverride() {
  override = {};
}

function readStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

export function getRuntimeConfig() {
  const stored = readStorage();
  const pick = (key, fallback) => override[key] ?? stored[key] ?? fallback;
  return {
    baseUrl: pick('baseUrl', ''),
    token: pick('token', ''),
    // raw: el token ya trae el prefijo (SherpaCRM guarda «bearer …»); bearer: se antepone.
    rawToken: pick('rawToken', false),
    lang: pick('lang', 'es_es'),
    profile: pick('profile', ''),
    embedded: !!override.embedded,
  };
}

export function saveRuntimeConfig(partial) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readStorage(), ...partial }));
  } catch {
    // sin localStorage (modo privado): la config vive solo en memoria
    setRuntimeOverride(partial);
  }
}
